<template>
  <div class="back-top" @click="scrollToTop" v-show="show">
    <i class="el-icon-arrow-up"/>
  </div>
</template>

<script>
export default {
  name: 'BackTop',
  data() {
    return {
      show: false
    }
  },
  mounted() {
    // 监听滚动
    window.addEventListener('scroll', this.scroll);
  },
  methods: {
    scroll() {
      let scrollTop = document.documentElement.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = document.documentElement.clientHeight; //能看到的页面的高度
      // let scrollHeight = document.documentElement.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      // let total = scrollTop + windowHeitht
      // console.log('scrollTop', scrollTop)
      if (scrollTop > 1080) {
        this.show = true
      } else {
        this.show = false
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.back-top {
  height: 4rem;
  width: 4rem;
  background-color: #1989fa;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  text-align: center;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
  position: fixed;
  bottom: 4rem;
  right: 4rem;
  z-index: 999;
  font-size: 1.8rem;
}
</style>


// WEBPACK FOOTER //
// src/views/Layout/components/BackTop.vue